import { MultiLanguageTextData } from 'api/types/data/directory/directory';
import { getYesOrNoLabel } from 'helpers';
import { TFunc } from 'libs/i18n';

interface Props {
  t: TFunc;
  language: 'en' | 'ru';
  fieldValue:
    | string
    | number
    | boolean
    | MultiLanguageTextData
    | undefined
    | null;
}
export const convertDirectoryFieldValueToLabel = ({
  t,
  language,
  fieldValue,
}: Props) =>
  fieldValue === undefined || fieldValue === null
    ? ''
    : typeof fieldValue === 'object'
    ? fieldValue[language] || fieldValue.ru
    : typeof fieldValue === 'boolean'
    ? getYesOrNoLabel(t, fieldValue)
    : fieldValue;
